import CheckoutMap from './checkout-map';

'use strict';

class CheckoutStep {
  constructor(elem) {
    this.stepContainer = elem;
    this.stepsWrapper = this.stepContainer.closest('[data-accommodation-active-step]');
    this.buttonModify = this.stepContainer.querySelector('[data-modify-step]');
    this.events();
  }

  open() {
    this.stepContainer.classList.add('active');
  }

  closeStep() {
    this.stepContainer.classList.remove('active');
  }

  events() {
    if (this.buttonModify) {
      this.buttonModify.addEventListener('click', (e) => {
        // const activeStep = this.stepsWrapper.dataset.accommodationActiveStep;
        const stepIndex = Array.from(this.stepsWrapper.children).indexOf(this.stepContainer);
        this.stepsWrapper.dataset.accommodationActiveStep = stepIndex + 1;
        document.dispatchEvent(new CustomEvent('editStep', { detail: { stepIndex: stepIndex + 1 }}));
        this.open();
      });
    }

    window.onpageshow = function(event) {
      if (event.persisted && utils.mq.sm.matches) {
        this.stepsWrapper.dataset.accommodationActiveStep = 1;
        this.stepsWrapper.querySelector('[data-step-toggle-active]').addClass('active');
      }
    };
  }
}

const toggleStepContainers = document.querySelectorAll('[data-step-toggle-active]');
for (let toggleStepContainer of toggleStepContainers) {
  toggleStepContainer.toggleStep = new CheckoutStep(toggleStepContainer);
}